// John Eldhose 20200626
import React, { Component } from 'react';
import { CircularProgress, Grid } from '@material-ui/core';

class Loading extends Component {
  render() {
    var mh = ((typeof this.props.minHeight === 'undefined') ? 200 : this.props.minHeight) + 'px';
    return (
      <Grid container
        alignItems='center' justify='center' style={{ minHeight: mh }}
      >
        <CircularProgress size={50} style={{ color: '#00A8E4' }} />
      </Grid>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/lib/Loading.js